import {Component, Input, OnInit} from '@angular/core';
import {EmailRendererTestService} from './email-renderer-tests/email-renderer-test/email-renderer-test.service';
import {EmailRendererTestResult} from './email-renderer-tests/email-renderer-test/email-renderer-test-results/email-renderer-test-result/email-renderer-test-result';
import {EmailRendererClientsService} from './email-renderer-clients/email-renderer-clients.service';
import {FormControl, FormGroup} from '@angular/forms';
import {EmailRendererTestResultsService} from './email-renderer-tests/email-renderer-test/email-renderer-test-results/email-renderer-test-results.service';

@Component({
    selector: 'vui-email-renderer',
    templateUrl: './email-renderer.component.html',
    styleUrls: ['./email-renderer.component.scss']
})
export class EmailRendererComponent implements OnInit {
    public emailRendererTestResults: Array<EmailRendererTestResult>;
    public formGroup: FormGroup;
    @Input() public html: string;
    @Input() public subject: string;

    constructor(private emailRendererClientsService: EmailRendererClientsService,
                private emailRendererTestResultsService: EmailRendererTestResultsService,
                private emailRendererTestService: EmailRendererTestService) {
        this.emailRendererTestResults = new Array<EmailRendererTestResult>();
        this.formGroup = new FormGroup({
            client: new FormControl('')
        });
    }

    ngOnInit() {
        this.emailRendererTestService.post(this.html, this.subject).subscribe((emailRendererTest) => {
            this.emailRendererTestResultsService.get(emailRendererTest.id).subscribe((emailRendererTestResults) => {
                this.emailRendererTestResults = emailRendererTestResults;
            });
        });
    }
}
